import { useCallback } from "react";
import { AccountType } from "@common/constants/domains/accounting/accounts";
import { useWorkspaceAccrualAccounts } from "@api/account.api";

/** Schedules recode a transaction on the accrual ledger, so that is the account whose type they check. */
export function useAccrualAccountTypeLookup(): (
    accountId: string | null | undefined,
) => AccountType | null {
    const { data: accrualAccounts } = useWorkspaceAccrualAccounts();
    return useCallback(
        (accountId) =>
            accrualAccounts?.find((account) => account.id === accountId)
                ?.type ?? null,
        [accrualAccounts],
    );
}

export function useAccrualAccountType(
    accountId: string | null | undefined,
): AccountType | null {
    return useAccrualAccountTypeLookup()(accountId);
}
